import Api from '../../../services';

export const getEntities = (listingId) => {
  return (dispatch) => {
    return Api.hostApi.entities.getEntities(listingId).then((response) => {
      dispatch({
        type: 'GET_ENTITIES',
        data: response,
      });
      return response;
    });
  };
};

export const createEntity = (listingId, data) => {
  return (dispatch) => {
    return Api.hostApi.entities.createEntity(listingId, data).then((response) => {
      dispatch({
        type: 'CREATE_ENTITY',
        data: response,
      });
      return response;
    });
  };
};

export const updateEntity = (listingId, entityId, data) => {
  return (dispatch) => {
    return Api.hostApi.entities.updateEntity(listingId, entityId, data).then((response) => {
      dispatch({
        type: 'UPDATE_ENTITY',
        data: response,
      });
      return response;
    });
  };
};

export const deleteEntity = (listingId, entityId) => {
  return (dispatch) => {
    return Api.hostApi.entities.deleteEntity(listingId, entityId).then((response) => {
      dispatch({
        type: 'DELETE_ENTITY',
        data: response,
      });
      return response;
    });
  };
};
